module.exports = __webpack_public_path__ + "img/aquatic-staff-2.7af35528.jpg";